import Jayalakshmi from "../../images/Coordinators/Jayalakshmi.webp"
import Bhuvaneswaran from "../../images/Coordinators/Bhuvaneswaran.webp"
import Adlin from "../../images/Coordinators/Adlin.webp"
import Sabitha from "../../images/Coordinators/Sabitha.webp"
import Kumar from "../../images/Coordinators/kumar.jpg"

const CoordinatorData = [
  {
    imageSrc: Kumar,
    name: "Dr. Kumar P",
    position: "Convenor",
  },
  {
    imageSrc: Jayalakshmi,
    name: "Ms. Jaeyalakshmi M",
    position: "Faculty Coordinator",
  },
  {
    imageSrc:Bhuvaneswaran,
    name: "Mr.Bhuvaneswaran B",
    position: "Faculty Coordinator",
  },
  {
    imageSrc:Sabitha,
    name: "Dr. Sabitha R",
    position: "Faculty Coordinator",
  },
  {
    imageSrc:Adlin,
    name: "Ms. Adlin Layola",
    position: "Faculty Coordinator",
  }
]

export default CoordinatorData;